import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Loading from '../components/Loading';
import ErrorPage from './error';
import FileSaver from 'file-saver';
import '../styles/pages/admin.scss';

const CancelToken = axios.CancelToken;
let cancel;

const Logs = () => {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [fileNames, setFileNames] = useState();

    useEffect(() => {
        fetchLogList();
    }, []);

    function fetchLogList() {
        const url = `api/logs/`;
        cancel && cancel();

        try {
            axios
                .get(url, {
                    cancelToken: new CancelToken((c) => {
                        cancel = c;
                    }),
                })
                .then((response) => {
                    const data = response.data;
                    setFileNames(
                        data &&
                            data.sort((a, b) => {
                                return b - a;
                            })
                    );
                    setIsLoading(false);
                })
                .catch((thrown) => {
                    if (axios.isCancel(thrown)) {
                        console.error('Request canceled', thrown.message);
                    } else {
                        const error = thrown.response;
                        setError(error);
                        setIsLoading(false);
                    }
                });
        } catch (error) {
            setError(error);
        }
    }

    function fetchLogFile(fileName) {
        const url = `api/logs/file?filename=${encodeURIComponent(fileName)}`;
        cancel && cancel();

        try {
            axios
                .get(url, {
                    cancelToken: new CancelToken((c) => {
                        cancel = c;
                    }),
                    responseType: 'blob',
                    headers: {
                        Accept: 'application/json, text/plain, */*',
                        'Content-Type': 'text/plain',
                    },
                })
                .then((response) => {
                    FileSaver.saveAs(response.data, fileName);
                })
                .catch((thrown) => {
                    if (axios.isCancel(thrown)) {
                        console.error('Request canceled', thrown.message);
                    } else {
                        const error = thrown.response;
                        setError(error);
                    }
                });
        } catch (error) {
            setError(error);
        }
    }

    const LogFile = (fileName) => {
        return (
            <div className='padding-bottom-5px'>
                <span className='log-file' onClick={() => fetchLogFile(fileName)}>
                    <span className='oi oi-document padding-right-5px c-licorice'></span>
                    {fileName.substring(fileName.indexOf('Registret'))}
                </span>
            </div>
        );
    };

    const content = isLoading ? (
        <Loading />
    ) : error && error ? (
        <ErrorPage error={error} />
    ) : (
        <section className='container padding-bottom-60px'>
            <h1 className='padding-top-40px'>Log Files</h1>
            <div className='row padding-top-20px'>
                <div className='col-lg-4'>
                    <h3>Web Logs</h3>
                    {fileNames &&
                        fileNames.map((fileName, index) => {
                            return fileName.includes('Registret-Web_Log') ? <div key={index}>{LogFile(fileName)}</div> : null;
                        })}
                </div>
                <div className='col-lg-4'>
                    <h3 className='log-category'>Web Access Logs</h3>
                    {fileNames &&
                        fileNames.map((fileName, index) => {
                            return fileName.includes('Registret-Web_Access') ? <div key={index}>{LogFile(fileName)}</div> : null;
                        })}
                </div>
                <div className='col-lg-4 offset-lg-0'>
                    <h3 className='log-category'>Api Logs</h3>
                    {fileNames &&
                        fileNames.map((fileName, index) => {
                            return fileName.includes('Registret-Server') ? <div key={index}>{LogFile(fileName)}</div> : null;
                        })}
                </div>
                <div className='col-lg-4 offset-lg-0'>
                    <h3 className='log-category'>DB Corrupt Assignments Logs</h3>
                    {fileNames &&
                        fileNames.map((fileName, index) => {
                            return fileName.includes('Registret-Corrupt-Assignments_Log') ? <div key={index}>{LogFile(fileName)}</div> : null;
                        })}
                </div>
            </div>
        </section>
    );
    return content;
};

export default Logs;
